import gql from 'graphql-tag';

export const GET_ESTATE_DETAILS = gql`
  query Property($propertyId: String!) {
    property(propertyId: $propertyId) {
      id
      userFav
      userDiscard
      title
      priceWater
      priceElectricity
      priceGas
      priceTIC
      address
      propertyLegalId
      latitude
      longitude
      status
      propertyType
      currencyIso
      administrationPrice
      price
      about
      isPriceDropped
      isExclusive
      media {
        id
        uri
        main
      }
      characteristics {
        value
        withValue
        name
        slug
        category
      }
      location {
        status
        name
        code
      }
      recommendations {
        kind
        calculationMethod {
          method
          version
        }
        recommendedEstates {
          legalId
          ranking {
            calculatedRank
            obtainedScoring
          }
          title
          type
          currencyISO
          administrationPrice
          price
          rooms
          bathrooms
          area
          image
          isAnewProperty
          isInHighDemand
          isFurnished
          status
          isPriceDropped
          propertyType
        }
      }
      locationMaps {
        url
        size
      }
      broker
    }
  }
`;
